import { Link } from "react-router-dom";
import { Phone, Mail, Clock, MapPin, ArrowRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/motion";
import { PHONE, PHONE_HREF, EMAIL, EMAIL_HREF, HOURS, CITIES } from "../lib/site";

const ROWS = [
  { i: Phone, k: "Phone", v: PHONE, href: PHONE_HREF, id: "contact-phone" },
  { i: Mail, k: "Email", v: EMAIL, href: EMAIL_HREF, id: "contact-email" },
  { i: Clock, k: "Office hours", v: HOURS, id: "contact-hours" },
  { i: MapPin, k: "Service area", v: `${CITIES.join(", ")} & nearby West Valley communities, AZ`, id: "contact-area" },
];

export default function Contact() {
  return (
    <>
      <Seo title="Contact Shine Solutions | Commercial Cleaning West Valley AZ" description={`Contact Shine Solutions about commercial cleaning in Peoria, Glendale and Surprise, AZ. Call ${PHONE} or request a quote online for your facility.`} path="/contact" />
      <PageHero kicker="Contact us" lines={["Talk to the", "person in charge."]} intro="Calls are answered by the team that manages your account. For new service, the quote form is the fastest route to a proposal." />
      <section className="bg-white py-24 md:py-36">
        <div className="mx-auto grid max-w-[1400px] gap-16 px-5 md:px-10 lg:grid-cols-12">
          <ul className="lg:col-span-7">
            {ROWS.map(({ i: Icon, k, v, href, id }, n) => (
              <Reveal as="li" key={k} delay={0.06 * n} className="border-b border-slate-200 py-8">
                <p className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-slate-500"><Icon className="h-4 w-4 text-emerald-700" /> {k}</p>
                {href
                  ? <><a href={href} data-testid={id} className={`mt-3 block break-all font-display font-semibold text-ink transition-colors hover:text-emerald-700 ${id === "contact-phone" ? "text-3xl md:text-5xl" : "text-xl md:text-3xl"}`}>{v}</a></>
                  : <p data-testid={id} className="mt-3 font-display text-xl text-ink md:text-2xl">{v}</p>}
              </Reveal>
            ))}
          </ul>
          <Reveal className="lg:col-span-5">
            <div className="rounded-[28px] bg-ink p-10 text-white">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-glint">New commercial service</p>
              <h2 className="mt-6 font-display text-3xl font-semibold leading-tight md:text-4xl">Start with a quote request.</h2>
              <p className="mt-4 text-base text-slate-300">Share your facility details once — we review, schedule a walkthrough if needed, and send a written proposal.</p>
              <Link to="/request-quote" data-testid="contact-quote-btn" className="btn-glint group mt-8">Request a Quote <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
